import { useContext, useEffect } from 'react';
import Tabs from '../components/Tabs';
import { TabItem } from '../interface/interface';
import { PatientDosageDiaryList } from './PatientDosageDiaryList';
import { UserContext } from '../context/userContext';

export function PatientDosageTabs() {
  const { userDetail, setActiveItem } = useContext(UserContext);

  useEffect(() => {
    setActiveItem('My Care Hub');
  }, []);

  const tabs: Array<TabItem> = [];

  if (userDetail.internal) {
    tabs.push({
      id: 'dosage-diary',
      label: 'Dosage Diaries',
      component: <PatientDosageDiaryList />,
    });
  }

  return (
    <div className="container-standard">
      <Tabs tabs={tabs} />
    </div>
  );
}
